import React from "react";
import CloseIcon from "../../svg/CloseIcon";
import { svgSizes } from "../../utils";
import BlockHeader from "../BlockHeader";
import BrightCoveVideoPlaylist from "../../../brightcove-video-playlist/main";

function VideoModal({ closeModal, videoList, label }) {
  return (
    <>
      <CloseIcon size={svgSizes.xSmall} handleClick={closeModal} wrapperElement={"button"} />
      <BlockHeader title={label} />
      <BrightCoveVideoPlaylist options={{ isAutoplay: true, videoList, disableUrlFragment: true, initialVideoPosition: 0 }} />
    </>
  );
}

export default VideoModal;
